export const EMPTY_POS_SALE_MESSAGE = 'Agrega productos antes de finalizar la venta.';

const hasValue = (value) => (
  value !== null
  && value !== undefined
  && String(value).trim() !== ''
);

const isPositiveIntegerId = (value) => {
  if (!hasValue(value)) return false;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0;
};

export const hasPosSaleItems = (purchaseItems) => (
  Array.isArray(purchaseItems) && purchaseItems.length > 0
);

export const shouldResetDocumentTypeAfterClientModal = ({
  pendingFinishAfterClient = false,
  pendingConversionAfterClient = false,
  pendingConversionAfterType = false,
} = {}) => (
  Boolean(
    pendingFinishAfterClient
    || pendingConversionAfterClient
    || pendingConversionAfterType
  )
);

export const buildPosClientAssignmentPayload = ({
  clientId,
  purchaseId = null,
  isRegisterlessMode = false,
} = {}) => {
  if (
    hasValue(purchaseId)
    || isRegisterlessMode
    || !isPositiveIntegerId(clientId)
  ) {
    return null;
  }

  return {
    saleStatus: 'open',
    paymentConfirmed: false,
    isPaid: false,
    documentType: null,
  };
};
